var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// related component
import '../database-block/table/table-view.js';
import { BlockElement } from '@blocksuite/lit';
import { nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
let DataViewBlockComponent = class DataViewBlockComponent extends BlockElement {
    render() {
        // data-view block has been deprecated
        return nothing;
    }
};
DataViewBlockComponent = __decorate([
    customElement('affine-data-view')
], DataViewBlockComponent);
export { DataViewBlockComponent };
//# sourceMappingURL=data-view-block.js.map